import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { HorizontalMenuItems } from './menu-items/horizontal-menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
//import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { DetailConfi } from './general/datageneral';
import { PlacesItems } from './general/places';

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    //ToggleFullscreenDirective
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    //ToggleFullscreenDirective
   ],
  providers: [ MenuItems, HorizontalMenuItems, DetailConfi, PlacesItems ]
})
export class SharedModule { }
